let faqCons = document.querySelectorAll('.content .accordion');

faqCons.forEach(function(item,i){
  let faqLink = item.querySelector('.faq-btn');
  let faqText = item.querySelector('.ac-wrap');
  faqLink.addEventListener('click', function(event){
    event.preventDefault();
    removeActive(i);
    faqLink.classList.toggle('flip');
    faqText.classList.toggle('appear');
  });
});

let removeActive = function(except){
  console.log("remove all except " + except);
  let getPees = document.querySelectorAll('.content .accordion .ac-wrap');
  let getRows = document.querySelectorAll('.content .accordion .faq-btn');
  getPees.forEach(function(item, i){
    if(i == except){

    } else {
      item.classList.remove("appear");
    }
    
  });

  getRows.forEach(function(item, i){
    if(i == except){

    } else {
      item.classList.remove("flip");
    }
    
  });
}

let getSelects = document.querySelectorAll('.sidebar select');

getSelects.forEach(function(item, i){
  item.addEventListener('focus',function(){
    getSelects.forEach(function(itemo, j){
      if(j == i){

      } else {
        itemo.classList.add('hide');
      }
    });
  })

  item.addEventListener('change',function(){
    getSelects.forEach(function(itemo, j){
      itemo.classList.remove('hide');
    })
  })
});